import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import React, { FC } from 'react';
import badInteriorPackaging from '../../../assets/badInteriorPackaging.png';
import badPackaging1 from '../../../assets/badPackaging1.png';
import badPackaging2 from '../../../assets/badPackaging2.png';
import checkMark from '../../../assets/checkMark.png';
import properInteriorPackaging from '../../../assets/properInteriorPackaging.png';
import properPackaging from '../../../assets/properPackaging.png';
import redX from '../../../assets/redX.png';
import { SiteHelpCallback } from '../../../constants';
import { useTranslation } from '../../blocks';
import { HelpBody, HelpCaptionedImage, HelpImage, HelpStep, HelpSubheading, HelpTitle } from './HelpElements';

const ShippingAndPackagingRequirementsHelp: FC<SiteHelpCallback> = () => {
    const { t } = useTranslation('shippingAndPackagingRequirementsHelp');

    return (
        <>
            <HelpTitle>{t('shippingAndPackagingRequirementsHelp_Title')}</HelpTitle>
            <HelpBody>{t('shippingAndPackagingRequirementsHelp_introParagraphOne')}</HelpBody>
            <HelpBody>{t('shippingAndPackagingRequirementsHelp_introParagraphTwo')}</HelpBody>
            <HelpStep step={1}>{t('shippingAndPackagingRequirementsHelp_consolidate')}</HelpStep>
            <HelpStep step={2}>{t('shippingAndPackagingRequirementsHelp_printEmail')}</HelpStep>
            <HelpStep step={3}>{t('shippingAndPackagingRequirementsHelp_labelCarton')}</HelpStep>
            <HelpStep step={4}>{t('shippingAndPackagingRequirementsHelp_shipToLocation')}</HelpStep>

            <HelpSubheading>{t('shippingAndPackagingRequirementsHelp_exteriorExample')}</HelpSubheading>
            <Row spacing={'small'} alignmentVertical={'top'} alignmentHorizontal={'left'} widths={['50%', '50%']}>
                <HelpCaptionedImage image={properPackaging}>
                    <HelpImage size={'icon'} src={checkMark} />
                    <HelpBody>{t('shippingAndPackagingRequirementsHelp_properPackaging')}</HelpBody>
                </HelpCaptionedImage>
                <Column heights={['50%', '50%']}>
                    <HelpCaptionedImage image={badPackaging1}>
                        <HelpImage size={'icon'} src={redX} />
                        <HelpBody>{t('shippingAndPackagingRequirementsHelp_badPackaging')}</HelpBody>
                    </HelpCaptionedImage>
                    <HelpCaptionedImage image={badPackaging2}>
                        <HelpImage size={'icon'} src={redX} />
                        <HelpBody>{t('shippingAndPackagingRequirementsHelp_badPackaging')}</HelpBody>
                    </HelpCaptionedImage>
                </Column>
            </Row>

            <HelpSubheading>{t('shippingAndPackagingRequirementsHelp_interiorExample')}</HelpSubheading>
            <Row spacing={'small'} alignmentVertical={'top'} alignmentHorizontal={'left'} widths={['50%', '50%']}>
                <HelpCaptionedImage image={properInteriorPackaging}>
                    <HelpImage size={'icon'} src={checkMark} />
                    <HelpBody>{t('shippingAndPackagingRequirementsHelp_properInteriorPackaging')}</HelpBody>
                </HelpCaptionedImage>
                <HelpCaptionedImage image={badInteriorPackaging}>
                    <HelpImage size={'icon'} src={redX} />
                    <HelpBody>{t('shippingAndPackagingRequirementsHelp_badInteriorPackaging')}</HelpBody>
                </HelpCaptionedImage>
            </Row>
        </>
    );
};

export { ShippingAndPackagingRequirementsHelp };
